var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 22,
    viewBox: "0 0 32 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1027 4.45507H2.07705C0.979277 4.45507 0.0898438 3.5717 0.0898438 2.48147C0.0898438 1.39124 0.979277 0.507812 2.07705 0.507812H29.1027C30.2004 0.507812 31.0898 1.39118 31.0898 2.48147C31.0898 3.57176 30.2004 4.45507 29.1027 4.45507Z",
    fill: "url(#paint0_linear_2389_8188)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9745 12.9786H2.07705C0.979277 12.9786 0.0898438 12.0951 0.0898438 11.0049C0.0898438 9.91468 0.979277 9.03125 2.07705 9.03125H17.9745C19.0722 9.03125 19.9617 9.91462 19.9617 11.0049C19.9617 12.0952 19.0722 12.9786 17.9745 12.9786Z",
    fill: "url(#paint1_linear_2389_8188)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1023 12.9786H25.9228C24.825 12.9786 23.9355 12.0952 23.9355 11.0049C23.9355 9.91462 24.825 9.03125 25.9228 9.03125H29.1023C30.2 9.03125 31.0894 9.91462 31.0894 11.0049C31.0894 12.0952 30.2 12.9786 29.1023 12.9786Z",
    fill: "url(#paint2_linear_2389_8188)",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1027 21.5098H2.07705C0.979277 21.5098 0.0898438 20.6264 0.0898438 19.5362C0.0898438 18.4459 0.979277 17.5625 2.07705 17.5625H29.1027C30.2004 17.5625 31.0898 18.4459 31.0898 19.5362C31.0898 20.6264 30.2004 21.5098 29.1027 21.5098Z",
    fill: "url(#paint3_linear_2389_8188)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2389_8188",
    x1: 15.5898,
    y1: 0.507812,
    x2: 15.5898,
    y2: 4.45507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2389_8188",
    x1: 10.0258,
    y1: 9.03125,
    x2: 10.0258,
    y2: 12.9786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2389_8188",
    x1: 27.5125,
    y1: 9.03125,
    x2: 27.5125,
    y2: 12.9786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2389_8188",
    x1: 15.5898,
    y1: 17.5625,
    x2: 15.5898,
    y2: 21.5098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menuIcon.447dcb820658771fd44b42a03a09a9be.svg";
export { ForwardRef as ReactComponent };